module.exports = "<div id=ng-dro-uaa-noData> <p class=\"no-data text-muted\" ng-if=\"ngModel.length <= 0 && ngModel\"> <i class=\"fa fa-lg fa-info\"></i> {{ 'uaa.no_data' | translate }} </p> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/directives/noData/noData.html
// module id = 364
// module chunks = 0